define('plugin/invoice/model/InvoicePaymentMethodModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Payment method model
     *
     * @class InvoicePaymentMethodModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/payment/payment-methods/id/',

        defaults: {
            id: '',
            name: '',
            selected: false,
            recurring: false,
            storedPaymentMethod: true
        }

    });

});
